"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLoading = exports.StyledLoadingContainer = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const Loading_types_1 = require("./Loading.types");
const rotate = (0, styled_components_1.keyframes) `
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
`;
const fadeIn = (0, styled_components_1.keyframes) `
    from {
      opacity: 0;
      transform: rotate(270deg);
    }
    to {
      opacity: 1;
      transform: rotate(360deg);
    }
`;
exports.StyledLoadingContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme, size }) => (size === Loading_types_1.LoadingSize.Small ? theme.sizes['4xs'].value : theme.sizes['2xs'].value)};
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: ${({ theme }) => theme.sizes['3xs'].value};
`;
exports.StyledLoading = styled_components_1.default.div `
  display: flex;

  svg {
    height: ${({ size }) => size};
    width: ${({ size }) => size};
  }
  &.fade-in {
    svg {
      animation: ${fadeIn} 1s;
    }
  }
  &.spinning {
    svg {
      animation: ${rotate} 2s linear infinite;
    }
  }
`;
//# sourceMappingURL=Loading.styled.js.map